import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { acceptAgreements } from "../../../slices/general/thunk";

// Import both agreement PDFs
import producerAgreement from "../../../assets/pdf/agreements/producer-agreement.pdf";
import organizationAgreement from "../../../assets/pdf/agreements/organization-agreement.pdf";

const SignAgreementModal = ({ open, setOpen, onAgreementSigned, type = "producer" }) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  // Determine the agreement title & file based on type
  const agreementTitle = type === "organization" ? "Organization Agreement" : "Producer Agreement";
  const agreementFile = type === "organization" ? organizationAgreement : producerAgreement;

  const toggleModal = () => setOpen(!open);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = agreementFile;
    link.setAttribute("download", `${agreementTitle}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(acceptAgreements());
      const res = response.payload;
      if (res && !res.error) {
        Swal.fire({
          icon: "success",
          title: "Agreement Signed",
          text: `You have successfully signed the ${agreementTitle}.`,
        });
        setOpen(false);
        onAgreementSigned(); // Notify parent component
      } else {
        throw new Error("Failed to sign agreement");
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong! Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="lg" backdrop="static" keyboard={false} isOpen={open} centered>
      <ModalHeader>{agreementTitle}</ModalHeader>
      <ModalBody>
        <p className="text-muted">Please review and agree to the following agreement.</p>
        <div className="text-center">
          <iframe
            src={agreementFile}
            style={{ width: "100%", height: "500px", border: "none" }}
            title={agreementTitle}
          ></iframe>
        </div>

        <div className="text-center mt-3">
          <Button color="primary" onClick={handleDownload}>
            Download {agreementTitle}
          </Button>
        </div>

        <Form className="mt-4">
          <FormGroup check>
            <Label check>
              <Input type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
              I agree and consent to the {agreementTitle}.
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit} disabled={!isChecked || loading}>
          {loading ? "Submitting..." : `Sign ${agreementTitle}`}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SignAgreementModal;